import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

// Auto-detect: Check if building for mobile (set by GitHub Actions)
// OR if running in Capacitor (runtime check)
const isMobileBuild = 
  process.env.REACT_APP_BUILD_TARGET === 'mobile' ||
  (typeof window !== 'undefined' && window.Capacitor);

// Conditionally import - bundler will tree-shake unused code
// Using dynamic import for better tree-shaking
let App;
if (isMobileBuild) {
  App = require('./App.mobile').default;
} else {
  App = require('./App').default;
}

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);

root.render(
  <StrictMode>
    <App />
  </StrictMode>
);


